import i18n from '@/i18n';

export default [
  {
    path: '/network-review',
    name: 'network-review',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'network',
          actions: ['list-all'],
        },
      ],
      title: i18n.global.t('network_review')
    },
    // route level code-splitting
    component: () =>
      import(
         '../../views/networkReview/Index'
      ),
  },
];
